<template>
  <div class="container">
    <div class="row mt-lg-5">
      <div class="col-lg-3 col-md-3"></div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <h1 class="ln-subtitle-text ln-darkblue mb-3">Prisijungimas</h1>
        <div v-if="isLoggedIn" class="ln-user-panel-menu-container">
          <div class="ln-user-panel-menu-header">Jūs esate prisijungę!</div>

          <div>
            <button class="btn ln-bnt-primary text-white m-2" @click="navigateToSearch">
              Eiti į paiešką
            </button>
          </div>
          <!-- <button class="btn ln-bnt-primary text-white m-2" @click="changePassword">
            Pakeisti slaptažodį
          </button> -->
          <div>
            <button
              v-if="isNewsletterEnabled"
              class="btn ln-bnt-primary text-white m-2"
              @click="() => this.$router.push('/newslettersubscription')"
            >
              Naujienlaiškio prenumerata
            </button>
          </div>
          <div>
            <button
              v-if="hasAdminRole"
              class="btn ln-bnt-primary text-white m-2"
              @click="() => this.$router.push('/manageinternaluser')"
            >
              <i class="fas fa-users" aria-hidden="true"></i>
              Naudotojai
            </button>
          </div>
          <div>
            <password-expired-form
              class="m-2 mb-5"
              v-if="isPasswordExpired"
            ></password-expired-form>
            <button
              class="btn ln-bnt-primary text-white m-2"
              type="button"
              @click="logout()"
            >
              <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
              Atsijungti
            </button>
          </div>
        </div>
        <div v-else>
          <login-form v-if="loginMode" @remember="remember"></login-form>
          <remember-password-form v-else></remember-password-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from "./Components/login-form";
import RememberPasswordForm from "./Components/remember-password-form";
import PasswordExpiredForm from "./Components/password-expired-form";
import { UserInfo } from "../Assets/repository";
import { userService } from "../_Services/user-service";

export default {
  name: "login-page",
  components: { LoginForm, RememberPasswordForm, PasswordExpiredForm },
  created() {
    this.tokenExpires = localStorage.getItem("tokenExpires");
    if (this.tokenValid) {
      UserInfo()
        .then((res) => {
          this.userValid = res.data.id !== undefined;
        })
        .catch(() => (this.userValid = false));
    }
  },
  mounted() {
    this.token = this.$route.query.token;
    if (this.token != undefined) {
      userService.sendPasswordRestoreToken(this.token);
      location.href = `${process.env.VUE_APP_BASE_URL}logininternaluser`;
    }
  },
  computed: {
    isLoggedIn() {
      return this.tokenValid && this.userValid;
    },
    tokenValid() {
      const today = new Date();
      const tokenExpires = new Date(this.tokenExpires);
      return tokenExpires > today;
    },
    hasAdminRole() {
      const tokenData = userService.tokenData();
      return tokenData.Role == 1;
    },
    isPasswordExpired() {
      return Boolean(localStorage.getItem("passwordExpired") == "true");
    },
    isNewsletterEnabled() {
      return process.env.VUE_APP_ENABLE_NEWSLETTER === "true";
    },
  },
  methods: {
    remember() {
      this.loginMode = false;
    },
    changePassword() {
      localStorage.setItem("passwordExpired", "true");
      // redraw dom
      this.$router.go(0);
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("tokenExpires");
      localStorage.removeItem("passwordExpired");
      setTimeout(function () {
        location.href = `${process.env.VUE_APP_BASE_URL}`;
      }, 1000);
    },
    navigateToSearch() {
      this.$router.push("/");
    },
  },
  data() {
    return {
      loginMode: true,
      tokenExpires: "",
      userValid: false,
      token: "",
    };
  },
};
</script>

<style lang="css" scoped></style>
